import { Trans, useTranslation } from "react-i18next";

import type { OrgInvitePreview as Preview } from "@/lib/types";

type Props = {
  preview: Preview;
  children?: React.ReactNode;
};

export function InvitePreview({ preview, children }: Props) {
  const { t } = useTranslation();
  const expired = new Date(preview.expires_at) < new Date();
  const decided = preview.accepted_at || preview.revoked_at;
  return (
    <div className="card mx-auto mt-12 max-w-md space-y-4">
      <h1 className="text-xl font-semibold">{t("ui.invitePreview.title")}</h1>
      <p className="text-sm text-nb-text">
        <Trans
          i18nKey="ui.invitePreview.rolePrompt"
          count={preview.role_slugs.length}
          values={{ org: preview.org.name, roles: preview.role_slugs.join(", ") }}
          components={{
            strong: <strong className="text-nb-text" />,
            code: <code className="text-nb-mint" />,
          }}
        />
      </p>
      {preview.invited_by_email && (
        <p className="text-xs text-nb-text-2">
          {t("ui.invitePreview.invitedBy", { email: preview.invited_by_email })}
        </p>
      )}
      <p className="text-xs text-nb-text-3">
        {t("ui.invitePreview.sentTo", { email: preview.invited_email })}
      </p>

      {preview.accepted_at && (
        <p role="alert" className="text-sm text-cvp-warn">
          {t("ui.invitePreview.acceptedNotice")}
        </p>
      )}
      {preview.revoked_at && (
        <p role="alert" className="text-sm text-cvp-danger">
          {t("ui.invitePreview.revokedNotice")}
        </p>
      )}
      {expired && !decided && (
        <p role="alert" className="text-sm text-cvp-warn">
          {t("ui.invitePreview.expiredNotice")}
        </p>
      )}

      {!decided && !expired && children}
    </div>
  );
}